class Search {
	constructor() {
        const searchClickEvent = new Event("searchOpen");
		window.dispatchEventSearchOpen = function() {
			document.dispatchEvent(searchClickEvent);
		}
	}
}

export default Search;